export default __webpack_public_path__ + "static/media/help-rav-v-1.69e40edd.png";